import React, { useState, useEffect } from "react";
import { Row, Col, Card, message, Divider } from "antd";
import { ReadOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { RenderPdf } from "../../../components/renderPdf";
import http from "../../../services/http";

export const TreinamentosDetalhes = () => {
  const navigate = useNavigate();
  const { id_treinamento } = useParams();
  const [loading, setLoading] = useState(false);
  const [arquivo, setArquivo] = useState(null);

  useEffect(() => {
    if (id_treinamento) {
      carregarTreinamentoDocumento(id_treinamento);
    }
  }, [id_treinamento]);

  // CARREGAR DOCUMENTO
  const carregarTreinamentoDocumento = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("file", `v1/treinamentos/carregar_documento/${id}`, []);
    if (api.statusCode === 200) {
      if (!api.response.data) {
        navigate("/treinamentos");
      }
      // CRIAR ARQUIVO PDF
      var blob = new Blob([api.response.data], {
        type: "application/pdf",
      });
      const url = window.URL.createObjectURL(blob);
      setArquivo(url);
    } else {
      navigate("/treinamentos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Treinamentos & Desenvolvimento" onClickBack={() => navigate("/treinamentos")} />
            <HeaderTitle
              title="Meus Treinamentos & Desenvolvimento"
              loading={loading}
              subtitle="Treinamento detalhes"
              icon={<ReadOutlined />}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <RenderPdf file={arquivo} />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
